module.exports = __webpack_public_path__ + "img/dp-sy-lm4.88e2a174.png";